import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=7f2e556d&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=js&"
export * from "./Diff.vue?vue&type=script&lang=js&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=7f2e556d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e556d",
  null
  
)

export default component.exports